<script>
	import { onMount } from 'svelte';
	import { onboardingAPI } from '../api.js';
	import Icon from './Icon.svelte';

	let { onNavigate = (_view) => {} } = $props();

	let status = $state(null);

	const STEPS = [
		{ key: 'channel_connected', label: 'Conecta tu primer canal', desc: 'WhatsApp, web chat o redes sociales', view: 'channels', icon: 'globe' },
		{ key: 'ai_agent_created', label: 'Crea un agente IA', desc: 'Para que responda por ti 24/7', view: 'ai-agents', icon: 'sparkles' },
		{ key: 'contact_added', label: 'Agrega tus contactos', desc: 'Importa un CSV o crea el primero', view: 'contacts', icon: 'users' },
		{ key: 'team_invited', label: 'Invita a tu equipo', desc: 'Atiendan juntos las conversaciones', view: 'users', icon: 'user' }
	];

	let doneCount = $derived(
		status ? STEPS.filter(s => status.steps[s.key]).length : 0
	);
	let visible = $derived(status && !status.completed && !status.dismissed);

	onMount(async () => {
		try { status = await onboardingAPI.status(); } catch {}
	});

	async function dismiss() {
		try {
			await onboardingAPI.dismiss();
			status = { ...status, dismissed: true };
		} catch {}
	}
</script>

{#if visible}
	<section class="onboarding card">
		<div class="ob-head">
			<div>
				<h3>Primeros pasos 🚀</h3>
				<p class="ob-sub">Completa estos pasos para sacarle el máximo a Mangu.</p>
			</div>
			<div class="ob-progress">
				<span class="ob-count">{doneCount}/{STEPS.length}</span>
				<div class="ob-bar"><div class="ob-fill" style="width:{(doneCount / STEPS.length) * 100}%"></div></div>
			</div>
			<button class="ob-dismiss" onclick={dismiss} title="Omitir">
				<Icon name="x" size={14} />
			</button>
		</div>
		<div class="ob-steps">
			{#each STEPS as step}
				{@const done = status.steps[step.key]}
				<button class="ob-step" class:done onclick={() => !done && onNavigate(step.view)} disabled={done}>
					<span class="ob-check" class:on={done}>
						{#if done}<Icon name="check" size={12} />{:else}<Icon name={step.icon} size={14} />{/if}
					</span>
					<span class="ob-text">
						<span class="ob-label">{step.label}</span>
						<span class="ob-desc">{step.desc}</span>
					</span>
					{#if !done}<Icon name="arrow-right" size={14} />{/if}
				</button>
			{/each}
		</div>
	</section>
{/if}

<style>
	.onboarding { padding: 18px; margin-bottom: 18px; border-left: 3px solid var(--accent); }
	.ob-head { display: flex; align-items: flex-start; gap: 14px; margin-bottom: 14px; }
	.ob-head h3 { font-size: 15px; }
	.ob-sub { color: var(--text-3); font-size: 12.5px; margin-top: 2px; }
	.ob-progress { margin-left: auto; display: flex; align-items: center; gap: 8px; }
	.ob-count { font-size: 12px; font-weight: 700; color: var(--accent); }
	.ob-bar { width: 90px; height: 6px; background: var(--surface-2); border-radius: 3px; overflow: hidden; }
	.ob-fill { height: 100%; background: var(--accent); border-radius: 3px; transition: width 300ms var(--ease); }
	.ob-dismiss {
		width: 26px; height: 26px;
		display: flex; align-items: center; justify-content: center;
		border-radius: 6px; color: var(--text-3);
	}
	.ob-dismiss:hover { background: var(--surface-2); color: var(--text-1); }

	.ob-steps { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 8px; }
	.ob-step {
		display: flex; align-items: center; gap: 10px;
		padding: 10px 12px;
		border: 1px solid var(--border-1);
		border-radius: 8px;
		text-align: left;
		transition: border-color var(--transition-fast), background var(--transition-fast);
	}
	.ob-step:not(.done):hover { border-color: var(--accent); background: var(--accent-soft); }
	.ob-step.done { opacity: 0.65; cursor: default; }
	.ob-check {
		width: 28px; height: 28px; flex-shrink: 0;
		border-radius: 50%;
		display: flex; align-items: center; justify-content: center;
		background: var(--surface-2); color: var(--text-2);
	}
	.ob-check.on { background: var(--success); color: #fff; }
	.ob-text { flex: 1; display: flex; flex-direction: column; min-width: 0; }
	.ob-label { font-size: 13px; font-weight: 600; color: var(--text-1); }
	.ob-step.done .ob-label { text-decoration: line-through; }
	.ob-desc { font-size: 11.5px; color: var(--text-3); }
</style>
